/* @flow */

import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import WorkbenchIcon from '../WorkbenchIcon/WorkbenchIcon';
import WorkbenchIcons from '../WorkbenchIcon/WorkbenchIcons';

type $Props = {
  pageCount: number,
  initialPage?: number,
  onPageChange: Function,
  wrapperClassName?: string,
  forcePage?: number
};

class Pagination extends Component<$Props> {

  onPageChange = (selectedPage: Object) => {
    this.props.onPageChange(selectedPage.selected + 1);
  };

  render() {
    const { pageCount, forcePage } = this.props;
    const baseClassName = 'dl-c-pagination';
    let optProps: Object = {};
    if (forcePage) optProps.forcePage = (forcePage - 1);
    return (
      <div className={this.props.wrapperClassName || ''}>
        <ReactPaginate
          pageCount={pageCount}
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          initialPage={0}
          previousLabel={<WorkbenchIcon icon={WorkbenchIcons.ICO_ARROW_4 } />}
          nextLabel={<WorkbenchIcon icon={WorkbenchIcons.ICO_ARROW_4} />}
          containerClassName={baseClassName}
          pageClassName={`${baseClassName}__item`}
          breakClassName={`${baseClassName}__break`}
          previousClassName={`${baseClassName}__prev`}
          nextClassName={`${baseClassName}__next`}
          activeClassName={`${baseClassName}__active`}
          disabledClassName={`${baseClassName}__disabled`}
          onPageChange={this.onPageChange}
          disableInitialCallback={false}
          {...optProps}
        />
      </div>
    );
  }
}

export default Pagination;
